export default __webpack_public_path__ + "static/media/evanepal.7c03f017.png";